import Vue from 'vue';
import VueCompositionApi, { reactive, Ref, computed } from '@vue/composition-api';
import { getStory } from '@/storyblok';

import { Immutable, Stateful } from './common';

Vue.use(VueCompositionApi);

// TODO evalutate https://github.com/43081j/id3 for id3 tags from mp3s

export type RecordPlayer = 'RecordPlayerPhilips' | 'RecordPlayerTechnics' | 'RecordPlayerTeac';

// TODO evalutate https://github.com/43081j/id3 for id3 tags from mp3s

export type AudioSource = string | string[];
export type AudioTrack = {
  readonly id: number;
  src: AudioSource;
};

export type AudioTrackInfo = {
  recordPlayer: RecordPlayer;
  title: string;
  artist: string;
  teaser: string;
  modalslug: string;
  duration?: number;
  cover: {
    filename: string;
    alt?: string;
  };
  audioFile?: {
    filename: string;
  };
  newAudioFile?: {
    audio: string;
    duration: number;
  };
};

export type StoryblokAudioLibState = {
  audioLib: AudioTrackInfo[];
};

export const DefaultAudioLibState: StoryblokAudioLibState = {
  audioLib: [],
};

export type StoryblokAudioLibModel = Stateful<StoryblokAudioLibState> & {
  type: 'StoryblokAudioLibModel';
  getAudioTrackInfo(audioTrack: Immutable<Ref<AudioTrack | undefined>>): Immutable<Ref<AudioTrackInfo | undefined>>;
};

export function createStoryblokAudioLibModel(state = DefaultAudioLibState): StoryblokAudioLibModel {
  // deep copy trick with json serialization
  const _state: StoryblokAudioLibState = reactive(JSON.parse(JSON.stringify(state)));

  // fetch current audio track info
  async function fetchAudioTrackInfo() {
    const story = await getStory('/audio-tracks', 'published');
    _state.audioLib = story.content.audioTracks;
    // console.log(story.content.audioTracks.filter((e:any) => e.title === 'Rising'));
  }

  function getAudioTrackInfo(audioTrack: Immutable<Ref<AudioTrack | undefined>>): Immutable<Ref<AudioTrackInfo | undefined>> {
    return computed(() =>
      audioTrack.value
        ? _state.audioLib.find((ti) => ti.newAudioFile?.audio === audioTrack.value?.src || ti.audioFile?.filename === audioTrack.value?.src)
        : undefined
    );
  }

  fetchAudioTrackInfo();

  return {
    type: 'StoryblokAudioLibModel',
    getAudioTrackInfo,
    state: _state,
  };
}
